export const IMPORT_TYPES = {
  FILE: 1,
  MANUAL: 2,
}

export const ACTIVITY_TYPES = {
  1: 'EMAIL_CAMPAIGN_PARTICIPATION',
  2: 'NOTE_ADDED',
  3: 'RECIPIENT_UNSUBSCRIBED_EMAIL',
  4: 'RECIPIENT_UNSUBSCRIBED_SMS',
  5: 'SMS_CAMPAIGN_PARTICIPATION',
  6: 'RECIPIENT_UNSUBSCRIBED_SPAM',
  7: 'RECIPIENT_UNSUBSCRIBED_HARD_BOUNCED',
}

export const ACTIVITY_TYPE_NAMES = {
  1: 'EMAIL',
  2: 'NOTE',
  3: 'UNSUBSCRIBED_EMAIL',
  4: 'UNSUBSCRIBED_SMS',
  5: 'SMS',
  6: 'UNSUBSCRIBED_SPAM',
  7: 'UNSUBSCRIBED_HARD_BOUNCED',
}

export const IMPORT_CONTACTS_STEPS = {
  IMPORT_CONTACTS: 1,
  MATCH_COLUMNS: 2,
  CREATE_AUDIENCE: 3,
}
